import React from 'react';
import { Link } from 'react-router-dom';
import { formatDate, formatTime } from 'utils/moment';
// import { Interpunct } from 'components/card/elements';
import {
  CardRow,
  OrderItemWrapper,
  Circle,
  Group,
  CheckBoxWrapper
} from './elements';
import { useStateValue } from 'context/store';
import { setTicketId, toggleModal } from 'context/orders/actions';
import { Interpunct } from 'components/card/elements';
import ModalComponent from 'components/modal2';
import EventTicket from 'containers/TicketOrder/EventTicket';
import { Input } from 'components/input';

function Order(props) {
  const { dispatch } = useStateValue();
  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  const {
    id,
    created,
    attendee_name,
    thumbnail,
    event_name,
    event_poster,
    type,
    name,
    authors,
    store_name,
    unit_price,
    currency,
    payment_method,
    updated,
    customer,
    content_type_name,
    ticket_files,
    ticket_name,
    order_number,
    poster_url,
    reservations,
    selectedTickets,
    setSelectedTickets
  } = props;

  function formatDate(isoString) {
    if (!isoString) return '';
    const date = new Date(isoString);
    return date
      .toLocaleDateString('en-GB', {
        weekday: 'short',
        day: '2-digit',
        month: 'short'
      })
      .replace('.', '');
  }

  const ticket = {
    ...props,
    ticket_number: props.ticket_label,
    customer: props.attendee_name,
    ticket_description: props.ticket_description,
    start_datetime: props.start_date,
    stop_datetime: props.stop_date,
    start_date: formatDate(props.start_date),
    stop_date: formatDate(props.stop_date)
  };

  function handleShare() {
    dispatch(setTicketId(id));
    dispatch(toggleModal());
  }

  const [isChecked, setIsChecked] = React.useState(false);

  React.useEffect(() => {
    setIsChecked(selectedTickets.some(t => t.id === ticket.id));
  }, [selectedTickets, ticket.id]);

  const handleCheckboxChange = e => {
    const checked = e.target.checked;
    setIsChecked(checked);

    if (checked) {
      setSelectedTickets(prev => {
        if (!prev.some(t => t.id === ticket.id)) {
          return [...prev, ticket];
        }
        return prev;
      });
    } else {
      setSelectedTickets(prev => prev.filter(t => t.id !== ticket.id));
    }
  };

  function handleContent() {
    switch (type) {
      case 'TICKET':
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              gap: 10
            }}
          >
            <CheckBoxWrapper>
              <Input
                type="checkbox"
                styles={{ width: 48, height: 48 }}
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
            </CheckBoxWrapper>
            <OrderItemWrapper {...props} style={{ width: '100%' }}>
              <CardRow style={{ marginTop: 0 }}>
                <div style={{ display: 'flex' }}>
                  <Circle
                    image={thumbnail}
                    style={{ marginRight: 7, verticalAlign: 'middle' }}
                  />{' '}
                </div>
                <p>{formatTime(created)}</p>
              </CardRow>
              <CardRow>
                <Group>
                  <p className="open-sans-semibold">{event_name}</p>
                  <p className="open-sans-semibold">{ticket_name}</p>
                </Group>
              </CardRow>
              <CardRow>
                <Group>
                  <p>{formatDate(created)}</p>
                  <p className="open-sans-bold">{attendee_name}</p>
                </Group>
                <Group className="text-right">
                  <p className="open-sans-bold">{order_number}</p>
                </Group>
              </CardRow>
              <CardRow className="overpass-mono-bold" style={{ marginTop: 28 }}>
                <button onClick={handleShare}>CHANGE TICKET NAME</button>
                <button
                  onClick={() => setModalIsOpen(true)}
                  style={{ textAlign: 'right' }}
                >
                  VIEW
                </button>
              </CardRow>

              <ModalComponent
                modalIsOpen={modalIsOpen}
                closeThisModal={() => setModalIsOpen(false)}
              >
                <EventTicket ticket={ticket} />
              </ModalComponent>
            </OrderItemWrapper>
          </div>
        );
      case 'STREAM':
        return (
          <OrderItemWrapper {...props}>
            <CardRow style={{ marginTop: 0 }}>
              <div style={{ display: 'flex' }}>
                <Circle
                  image={poster_url}
                  style={{ marginRight: 7, verticalAlign: 'middle' }}
                />{' '}
              </div>
              <p>{formatTime(created)}</p>
            </CardRow>
            <CardRow>
              <Group>
                <p className="open-sans-semibold">
                  {reservations[0]?.event_name}
                </p>
                <p className="open-sans-semibold">
                  {reservations[0]?.ticket_name}
                </p>
              </Group>
            </CardRow>
            <CardRow>
              <Group>
                <p>{formatDate(created)}</p>
                <p className="open-sans-bold">
                  {reservations[0]?.attendee_name}
                </p>
              </Group>
              <Group className="text-right">
                <p className="open-sans-bold">
                  {reservations[0]?.order_number}
                </p>
              </Group>
            </CardRow>
            <CardRow className="overpass-mono-bold" style={{ marginTop: 28 }}>
              {/* <button onClick={handleShare}>CHANGE TICKET NAME</button> */}
              <Link to={`/stream/${id}`}>STREAM EVENT</Link>
            </CardRow>
          </OrderItemWrapper>
        );
      default:
        return (
          <OrderItemWrapper {...props}>
            <CardRow style={{ marginTop: 0 }}>
              <div style={{ display: 'flex' }}>
                <Circle
                  image={
                    content_type_name === 'album' ? thumbnail : event_poster
                  }
                  style={{ marginRight: 7, verticalAlign: 'middle' }}
                />{' '}
                <p className="open-sans-bold" style={{ width: 200 }}>
                  {' '}
                  {store_name}
                </p>
              </div>
              <p>{formatTime(updated)}</p>
            </CardRow>
            <CardRow>
              {content_type_name === 'album' ? (
                <Group className="open-sans-semibold">
                  <p className="open-sans-semibold">{name}</p>
                  <p className="open-sans-semibold">
                    {authors && authors[0]} {Interpunct} {content_type_name}
                  </p>
                </Group>
              ) : (
                <Group>
                  <p className="open-sans-semibold">{event_name}</p>
                  <p className="open-sans-semibold">{ticket_name}</p>
                </Group>
              )}
            </CardRow>
            <CardRow>
              <p className="open-sans-semibold">
                {unit_price === 0 ? 'Free' : `${currency} ${unit_price}`}
              </p>
            </CardRow>
            <CardRow>
              <Group>
                <p>{formatDate(updated)}</p>
                <p className="open-sans-bold">{customer && customer.name}</p>
              </Group>
              <Group className="text-right">
                <p className="open-sans-bold">{order_number}</p>
                <p className="open-sans-semibold">{payment_method}</p>
              </Group>
            </CardRow>
            <CardRow className="overpass-mono-bold" style={{ marginTop: 28 }}>
              {content_type_name === 'ticket' && (
                <a
                  href={ticket_files && ticket_files[0].ticket_file}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  VIEW
                </a>
              )}
            </CardRow>
          </OrderItemWrapper>
        );
    }
  }

  return handleContent();
}

export default Order;
